export default "__VITE_ASSET__C6LXK14___"